/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { AccountTypes } from '@/features/account/context/account_view_context';
import {
  SIGNED_IN_USER_WITH_REWARDS_USER_TYPE,
  STAND_ALONE_USER_TYPE,
  MX_USER_TYPE,
} from '@/features/header/components/TopHeader/MobileHeaderSignIn/constants';
import type { MyProfileDataV2 } from '@/features/myProfile';
import { type ParsedUrlQuery } from 'querystring';

export function getAccountType(
  userAuthenticated: boolean,
  userData: MyProfileDataV2 | undefined,
  routerQuery: ParsedUrlQuery,
): AccountTypes {
  if (!userAuthenticated) {
    const hasLCID =
      !!routerQuery?.LCID &&
      (typeof routerQuery.LCID === 'string'
        ? routerQuery.LCID.length > 0
        : routerQuery.LCID.length > 0);

    if (hasLCID) {
      return 'Known Anonymous';
    }

    return 'Anonymous';
  }

  const userType = userData?.userType;

  if (userType === STAND_ALONE_USER_TYPE || userType === MX_USER_TYPE) {
    return 'Standalone Online';
  }
  if (userType === SIGNED_IN_USER_WITH_REWARDS_USER_TYPE) {
    return 'Online + Rewards';
  }

  return 'Anonymous';
}
